package com.sweetlime.bingeamigo.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Episode(
    val id: Int,
    val name: String,
    val overview: String = "",
    @SerialName("air_date")
    val airDate: String = "",
    @SerialName("episode_number")
    val episodeNumber: Int,
    @SerialName("season_number")
    val seasonNumber: Int,
    @SerialName("still_path")
    val stillPath: String? = null,
    @SerialName("vote_average")
    val voteAverage: Double = 0.0,
    val runtime: Int? = null
)

@Serializable
data class SeasonDetail(
    val id: Int,
    val name: String,
    val overview: String = "",
    @SerialName("air_date")
    val airDate: String = "",
    @SerialName("poster_path")
    val posterPath: String? = null,
    @SerialName("season_number")
    val seasonNumber: Int,
    val episodes: List<Episode> = emptyList()
)